var Loki = require('lokijs')
var LokiFsStructuredAdapter = require('../../node_modules/lokijs/src/loki-fs-structured-adapter.js')
var LokiIndexedAdapter = require('../../node_modules/lokijs/src/loki-indexed-adapter.js')
var LokiIndexedAdapter = require('../../node_modules/lokijs/src/loki-indexed-adapter.js')

export default {
  methods: {
    loadLoki: function (path, stringAdapter, autoload, autosave, autosaveInterval, isRegistry, promiseMsg) {

      var adapter;
      var options = {}
      switch (stringAdapter) {
        case 'registryIndexedAdapter':
          adapter = new LokiIndexedAdapter();
          break;
        case 'indexedAdapter':
          adapter = new Loki.LokiPartitioningAdapter(new LokiIndexedAdapter(), {
            paging: false
          });
          break;
        case 'fs':
          adapter = new Loki.LokiFsAdapter();
          break;
        case 'destructured':
          adapter = new LokiFsStructuredAdapter();
          options["serializationMethod"] = "destructured";
          break;
        case 'soloDestructured':
          options["serializationMethod"] = "destructured";
          break;
        default:
          adapter = null;
      }
      if (adapter) {
        options["adapter"] = adapter
      }
      var loki;
      var vm = this;
      return new Promise(function (resolve, reject) {
        if(promiseMsg)vm.setLoadingMessage(promiseMsg)
        if (autoload) {
          options["autoload"] = true;
          console.log("AUTO")
          options["autoloadCallback"] = function (err) {
            console.log("CALLED BACK")
            if (err) {
              //console.log("autoload rejecting");
              reject(err)
            } else {
              //console.log("autoload resolving");
              resolve(loki)
            }
          }
        }
        if (autosave) {
          options["autosave"] = autosave;
          if (autosaveInterval) {
            options["autosaveInterval"] = autosaveInterval
          }
        }
        if (!isRegistry) {
          loki = new Loki(path, options)
          if (!autoload) {
            loki.loadDatabase({}, function (err) {
              if (err) {
                //console.log("distinct load rejecting");
                reject(err)
              } else {
                //console.log("distinct load resolving");
                resolve(loki)
              }
            })
          }
        } else {
          vm.$root.dbServRegistry = new Loki(path, options)
          if (!autoload) {
            vm.$root.dbServRegistry.loadDatabase({}, function (err) {
              if (err) {
                //console.log("distinct load rejecting");
                reject(err)
              } else {
                //console.log("distinct load resolving");
                resolve(vm.$root.dbServRegistry)
              }
            })
          }
        }
      });
    },
    tempLoki: function(){
      var db = new Loki("temp.json");
      return db;
    },
    getLoki: function (name, obj) {
      var l = new Loki(name)
      l.loadJSONObject(obj)
      return l;
    },
    restoreCollection: function (collection) {

      //1 Ensure BinaryIndexes
      collection.ensureAllIndexes(true);

      //3 Ensure Unique Names
      if (collection.hasOwnProperty("uniqueNames")) {
        for (var j = 0; j < collection.uniqueNames.length; j++) {
          collection.ensureUniqueIndex(collection.uniqueNames[j]);
        }
      }
      return new Promise(function (resolve, reject) {
        //2 Ensure ID Array and MaxID
        if (typeof (Worker) !== "undefined") {
          // Yes! Web worker support!
          var worker = new Worker('../../static/js/restoreWorker.js');
          worker.addEventListener('message', function (e) {
            collection.maxId = e.data.maxId;
            collection.idIndex = e.data.idIndex;
            resolve();
            worker.terminate();
            worker = undefined;
          });
          worker.postMessage(collection.data);
        } else {
          var len = collection.data.length,
            i = 0;
          var maxId = -1;
          collection.idIndex = [];
          for (i; i < len; i += 1) {
            maxId = maxId < collection.data[i].$loki ? collection.data[i].$loki : maxId;
            collection.idIndex.push(collection.data[i].$loki);
          }
          collection.maxId = maxId;
          resolve();
        }
      });

    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/loki_db_loader.js